export const APL_BASE_URL = "https://corona-api.com";
